import CreateEditContingencyContainer from "./CreateEditContingencyContainer";
export default CreateEditContingencyContainer;
